(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusAssessByInitiativeDeliverablesController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'assessmentByInitiative', 'fiscalYearQuarterKeys'];

    function Controller($scope, $state, $stateParams, assessmentByInitiative, fiscalYearQuarterKeys) {

        if ($state.is('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables')) {

            // TODO: No Deliverables route
            if (fiscalYearQuarterKeys.length === 0) {
                $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeNoDeliverables',
                    {
                        PlanInitiativeID: $stateParams.PlanInitiativeID,
                    },
                    { location: 'replace' }
                );

                return;
            };

            $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverablesByQuarter',
                {
                    PlanInitiativeID: $stateParams.PlanInitiativeID,
                    FiscalYearQuarterKey: fiscalYearQuarterKeys[0],
                },
                { location: 'replace' }
            );

            return;
        }

        $scope.initiativesList = assessmentByInitiative.InitiativesList;
        $scope.planInitiative = assessmentByInitiative.PlanInitiative;
        $scope.assessmentByInitiative = assessmentByInitiative
    }
})();